import { ref } from "vue";
import ModbusWorker from "@/workers/ModbusWorker";

const modbusWorker = ref<ModbusWorker>();

export function useModbusWorker() {
  /**
   * Returns the singleton ModbusWorker instance, creating it if necessary.
   */
  function getModbusWorker(): ModbusWorker {
    if (!modbusWorker.value) {
      modbusWorker.value = new ModbusWorker();
    }
    return modbusWorker.value;
  }

  /**
   * Terminates the current worker and clears the reference so a fresh one
   * can be created via getModbusWorker().
   *
   * This is the fallback for when the SerialWorker is stuck (e.g., USB cable
   * unplugged during an active connection). In that scenario, the worker may be
   * blocked on a pending I/O operation and unable to process new messages.
   * Terminating the worker is the only way to recover.
   *
   * @see useModbusStore.closeSerial - calls this after a 2s timeout
   */
  function resetModbusWorker(): void {
    if (modbusWorker.value) {
      modbusWorker.value.terminate();
      modbusWorker.value = undefined;
    }
  }

  return {
    getModbusWorker,
    resetModbusWorker,
  };
}
